import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, Transition as _Transition, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "space-y-6"
};
const _hoisted_2 = {
  class: "bg-white rounded-2xl shadow-sm border border-slate-200/60 p-6"
};
const _hoisted_3 = {
  class: "grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "relative"
};
const _hoisted_6 = {
  class: "truncate text-center text-xs font-medium leading-5 text-slate-600 transition-colors group-hover:text-primary-700"
};
const _hoisted_7 = {
  class: "grid grid-cols-2 gap-6"
};
const _hoisted_8 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "w-14 py-2 bg-white/60 rounded-lg text-center border border-slate-100/50 shrink-0"
};
const _hoisted_11 = {
  class: "text-sm font-bold text-slate-800"
};
const _hoisted_12 = {
  class: "relative"
};
const _hoisted_13 = {
  class: "flex-1 min-w-0"
};
const _hoisted_14 = {
  class: "text-sm font-medium text-slate-800 truncate group-hover:text-primary-700 transition-colors"
};
const _hoisted_15 = {
  class: "text-xs text-slate-400 mt-0.5 flex items-center gap-1"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  class: "flex items-center gap-2 shrink-0"
};
const _hoisted_19 = {
  key: 0,
  class: "px-2 py-0.5 status-badge is-neutral text-xs font-medium rounded-full"
};
const _hoisted_20 = {
  key: 1,
  class: "px-2 py-0.5 status-badge is-info text-xs font-medium rounded-full"
};
const _hoisted_21 = {
  key: 2,
  class: "px-2 py-0.5 status-badge is-warning text-xs font-medium rounded-full"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_26 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_27 = {
  class: "flex items-center gap-2"
};
const _hoisted_28 = {
  key: 0,
  class: "px-2 py-0.5 status-badge is-success text-xs font-medium rounded-full"
};
const _hoisted_29 = {
  class: "flex items-center gap-2"
};
const _hoisted_30 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_31 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_32 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_33 = {
  key: 3,
  class: "space-y-2"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "min-w-0 flex-1"
};
const _hoisted_36 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_37 = {
  class: "min-w-0 flex-1 truncate text-sm font-medium text-slate-800 group-hover:text-emerald-700 transition-colors"
};
const _hoisted_38 = {
  class: "shrink-0 px-2 py-0.5 bg-white/80 text-emerald-700 text-xs font-medium rounded-full"
};
const _hoisted_39 = {
  class: "shrink-0 px-2 py-0.5 bg-white/80 text-slate-500 text-xs font-medium rounded-full"
};
const _hoisted_40 = {
  key: 0,
  class: "mt-0.5 line-clamp-2 text-xs text-slate-500"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  key: 4,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_43 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_44 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  class: "flex flex-col items-center gap-1 py-0.5 shrink-0"
};
const _hoisted_47 = {
  class: "flex-1 min-w-0"
};
const _hoisted_48 = {
  class: "flex items-center gap-2"
};
const _hoisted_49 = {
  class: "text-sm font-medium text-slate-800 truncate group-hover:text-primary-700 transition-colors"
};
const _hoisted_50 = {
  key: 0,
  class: "px-1.5 py-0.5 status-badge is-danger text-xs font-bold rounded-full shrink-0"
};
const _hoisted_51 = {
  key: 0,
  class: "text-xs text-slate-400 mt-0.5 line-clamp-2"
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = {
  class: "flex flex-col items-end gap-1 shrink-0"
};
const _hoisted_54 = {
  key: 0,
  class: "text-xs text-slate-500"
};
const _hoisted_55 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_56 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_57 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_58 = {
  class: "flex-1 min-w-0"
};
const _hoisted_59 = {
  class: "text-sm font-medium text-slate-800 truncate group-hover:text-orange-700 transition-colors"
};
const _hoisted_60 = {
  class: "text-xs text-slate-500 mt-0.5 line-clamp-2"
};
const _hoisted_61 = ["onClick"];
const _hoisted_62 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_63 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_64 = {
  class: "flex items-center gap-2"
};
const _hoisted_65 = {
  key: 0,
  class: "px-2 py-0.5 status-badge is-info text-xs font-medium rounded-full"
};
const _hoisted_66 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_67 = ["onClick"];
const _hoisted_68 = {
  class: "flex-1 min-w-0"
};
const _hoisted_69 = {
  class: "text-sm font-medium text-slate-800 truncate group-hover:text-blue-700 transition-colors"
};
const _hoisted_70 = {
  class: "text-xs text-slate-400 mt-0.5 flex items-center gap-1"
};
const _hoisted_71 = {
  class: "text-slate-500"
};
const _hoisted_72 = ["onClick"];
const _hoisted_73 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_74 = {
  class: "flex items-center justify-between mb-4 shrink-0"
};
const _hoisted_75 = {
  class: "flex items-center gap-2"
};
const _hoisted_76 = {
  key: 0,
  class: "px-2 py-0.5 status-badge is-purple text-xs font-medium rounded-full"
};
const _hoisted_77 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = {
  class: "flex-1 min-w-0"
};
const _hoisted_80 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_81 = {
  class: "text-sm font-medium text-slate-800 group-hover:text-primary-700 transition-colors"
};
const _hoisted_82 = {
  key: 0,
  class: "px-1.5 py-0.5 bg-red-100 text-red-700 text-xs font-bold rounded"
};
const _hoisted_83 = {
  key: 1,
  class: "px-1.5 py-0.5 bg-orange-100 text-orange-700 text-xs font-medium rounded"
};
const _hoisted_84 = {
  class: "text-xs text-slate-500 mt-0.5 line-clamp-2"
};
const _hoisted_85 = {
  class: "flex flex-col items-end gap-1.5 shrink-0"
};
const _hoisted_86 = {
  class: "text-xs text-slate-400 whitespace-nowrap"
};
const _hoisted_87 = ["onClick"];
const _hoisted_88 = {
  key: 0,
  class: "absolute top-3 right-3 w-2 h-2 bg-primary-500 rounded-full"
};
const _hoisted_89 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10"
};
const _hoisted_90 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4"
};
const _hoisted_91 = {
  class: "min-w-0"
};
const _hoisted_92 = {
  class: "truncate text-base font-semibold text-slate-900"
};
const _hoisted_93 = {
  key: 0,
  class: "mt-1 line-clamp-2 text-sm text-slate-500"
};
const _hoisted_94 = {
  class: "rounded-xl border border-slate-200 bg-slate-50/70 px-4 py-3"
};
const _hoisted_95 = {
  class: "mt-2 grid grid-cols-2 gap-2"
};
const _hoisted_96 = ["value"];
const _hoisted_97 = {
  class: "overflow-hidden rounded-xl border border-slate-200 bg-white"
};
const _hoisted_98 = {
  class: "flex items-center justify-between gap-3 border-b border-slate-100 px-4 py-3"
};
const _hoisted_99 = {
  class: "shrink-0 rounded-full status-badge is-neutral px-2 py-0.5 text-xs"
};
const _hoisted_100 = {
  class: "max-h-56 overflow-y-auto px-4 py-3"
};
const _hoisted_101 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-8 text-sm text-slate-500"
};
const _hoisted_102 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-8 text-center"
};
const _hoisted_103 = {
  key: 2,
  class: "rounded-lg border border-dashed border-slate-200 px-4 py-6 text-center text-sm text-slate-400"
};
const _hoisted_104 = {
  key: 3,
  class: "space-y-3"
};
const _hoisted_105 = {
  class: "flex flex-wrap items-center justify-between gap-2 text-xs text-slate-400"
};
const _hoisted_106 = {
  class: "font-medium text-slate-600"
};
const _hoisted_107 = {
  class: "mt-1.5 whitespace-pre-wrap break-words text-sm leading-6 text-slate-700"
};
const _hoisted_108 = {
  class: "border-t border-slate-100 bg-slate-50 px-4 py-3"
};
const _hoisted_109 = {
  class: "block"
};
const _hoisted_110 = {
  class: "mt-3 flex justify-end"
};
const _hoisted_111 = ["disabled"];
const _hoisted_112 = {
  class: "flex justify-end gap-2 border-t border-slate-200 pt-4"
};
const _hoisted_113 = ["disabled"];
const _hoisted_114 = ["disabled"];
import { ref, computed, onMounted, onUnmounted, h, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { useRouterStore } from '@/stores/router';
import { useUserStore } from '@/stores/user';
import { scheduleApi } from '@/api/schedule';
import { todoApi } from '@/api/todo';
import { approveTask } from '@/api/flow';
import { addWorkItemTodoAnnotation, getDailyWorkReport, getWorkReportAccessSummary, listWorkItemTodoAnnotations, saveSummaryDraft } from '@/api/workReport';
import AppModal from '@/components/AppModal.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import TodoDetailModal from '@/components/TodoDetailModal.vue';
import ScheduleDetailModal from '@/components/ScheduleDetailModal.vue';
import DashboardStatisticsSection from './components/DashboardStatisticsSection.vue';
import { useMessageStore } from '@/composables/useMessageStore';
import { useNotificationNavigation } from '@/composables/useNotificationNavigation';
import { useReminderToast } from '@/composables/useReminderToast';
import { useApprovalToast } from '@/composables/useApprovalToast';
import { chooseReminderTaskAction, reminderTaskActionMessage } from '@/utils/reminderTaskProcess';
import { createClientRequestId, getReportOptimisticVersion, normalizeReportTodoSnapshot, workReportItemSourceLabel } from '@/views/work-report/workReportUtils';
const dashboardCardClass = 'bg-white rounded-2xl shadow-sm border border-slate-200/60 p-6 h-[360px] flex flex-col overflow-hidden';
const dashboardCardBodyClass = 'min-h-0 flex-1 overflow-y-auto pr-1 space-y-2';

// 使用共享的消息状态
const REFRESH_INTERVAL = 60000; // 1分钟

export default {
  __name: 'Dashboard',
  setup(__props) {
    const router = useRouter();
    const routerStore = useRouterStore();
    const userStore = useUserStore();
    const {
      hasNotificationNavigation,
      navigateNotification
    } = useNotificationNavigation(router);
    const {
      unreadCount: messageUnreadCount,
      messages: storeMessages,
      loadUnreadCount,
      loadRecentMessages,
      markAsRead: storeMarkAsRead,
      markAllRead: storeMarkAllRead
    } = useMessageStore();

    // SVG Icon Components
    const PlusIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M12 4v16m8-8H4'
        })]);
      }
    };
    const CheckCircleIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        })]);
      }
    };
    const DocumentIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01'
        })]);
      }
    };
    const CubeIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
        })]);
      }
    };
    const CalendarIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
        })]);
      }
    };
    const AlertIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
        })]);
      }
    };
    const SuccessIcon = {
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M5 13l4 4L19 7'
        })]);
      }
    };

    // 快捷入口配置
    const quickActions = [{
      label: '新建方案',
      key: 'createProposal',
      path: '/proposal',
      permission: 'plan:save',
      icon: PlusIcon,
      iconBg: 'bg-primary-50 text-primary-600',
      badgeBg: 'bg-primary-500 text-white'
    }, {
      label: '审批中心',
      key: 'approval',
      path: '/approval',
      icon: CheckCircleIcon,
      iconBg: 'bg-primary-50 text-primary-600',
      badge: 3,
      badgeBg: 'bg-red-500 text-white'
    }, {
      label: '产品库',
      key: 'product',
      path: '/product',
      icon: CubeIcon,
      iconBg: 'bg-primary-50 text-primary-600'
    }, {
      label: '日程安排',
      key: 'schedule',
      path: '/schedule',
      icon: CalendarIcon,
      iconBg: 'bg-primary-50 text-primary-600'
    }];
    const workReportAccessSummary = ref(defaultWorkReportAccessSummary());
    const canOpenTeamWorkReport = computed(() => Boolean(workReportAccessSummary.value?.teamWorkbenchVisible));
    const workReportQuickActions = computed(() => {
      const summary = {
        ...defaultWorkReportAccessSummary(),
        ...(workReportAccessSummary.value || {})
      };
      const actions = [];
      if (summary.selfReportVisible !== false) {
        actions.push({
          label: '我的日报',
          key: 'workReportMy',
          path: '/work-reports/my',
          staticRoute: true,
          icon: DocumentIcon,
          iconBg: 'bg-primary-50 text-primary-600'
        });
      }
      if (summary.teamWorkbenchVisible) {
        actions.push({
          label: '团队日报',
          key: 'workReportTeam',
          path: '/work-reports/team',
          staticRoute: true,
          icon: CheckCircleIcon,
          iconBg: 'bg-primary-50 text-primary-600'
        });
      }
      return actions;
    });
    const visibleQuickActions = computed(() => {
      return [...quickActions, ...workReportQuickActions.value].filter(item => {
        if (item.visible === false) return false;
        return (item.staticRoute || hasRoutePermission(item.path)) && (!item.permission || userStore.hasPermission(item.permission));
      }).slice(0, 6);
    });
    function defaultWorkReportAccessSummary() {
      return {
        selfReportVisible: true,
        teamWorkbenchVisible: false,
        ruleManageVisible: false,
        defaultTeamScope: 'TEAM'
      };
    }
    const showStatisticsSection = computed(() => {
      return userStore.roleKeys.includes('FA-CITY-MANAGER') || userStore.roleKeys.includes('REGIONAL_PARTNER');
    });
    function hasRoutePermission(path) {
      if (!path) return true;
      return routerStore.dynamicRoutes.some(route => isRouteMatch(route, path));
    }
    function isRouteMatch(route, targetPath, parentPath = '') {
      const currentPath = getFullRoutePath(parentPath, route.path);
      if (currentPath === targetPath || targetPath.startsWith(`${currentPath}/`)) {
        return true;
      }
      return (route.children || []).some(child => isRouteMatch(child, targetPath, currentPath));
    }
    function getFullRoutePath(parentPath, path = '') {
      if (!path) return parentPath || '/';
      if (path.startsWith('/')) return path;
      if (!parentPath || parentPath === '/') return `/${path}`;
      return `${parentPath}/${path}`;
    }

    // 处理快捷入口点击
    function handleQuickAction(item) {
      if (item.key === 'createProposal') {
        // 跳转到方案管理页面并带上新建弹窗参数
        router.push({
          path: '/proposal',
          query: {
            create: 'true'
          }
        });
      } else if (item.key === 'approval') {
        // 跳转到审批中心
        router.push('/approval');
      } else if (item.key === 'product') {
        // 跳转到产品库
        router.push('/product');
      } else if (item.key === 'schedule') {
        // 跳转到日程安排
        router.push('/schedule');
      } else if (item.key === 'workReportMy') {
        router.push({
          path: '/work-reports/my'
        });
      } else if (item.key === 'workReportTeam') {
        router.push({
          path: '/work-reports/team',
          query: workReportAccessSummary.value?.defaultTeamScope === 'COPIED_TO_ME' ? {
            scope: 'copied'
          } : {}
        });
      }
    }

    // 通知消息 - 基于共享消息状态派生展示数据
    const notifications = computed(() => {
      return storeMessages.value.filter(item => !item.isRead).map(item => ({
        id: item.id,
        title: item.title || '',
        desc: item.content,
        time: item.time,
        bgClass: getBgClassByType(item),
        iconBg: getIconBgClass(item),
        icon: getIconByType(item.rawType),
        unread: !item.isRead,
        type: item.rawType,
        priority: item.priority,
        createTime: item.createTime,
        bizType: item.bizType,
        linkType: item.linkType,
        businessId: item.businessId,
        webUrl: item.webUrl,
        webPath: item.webPath,
        webNewWindow: item.webNewWindow,
        extraParams: item.extraParams
      }));
    });

    // 根据消息类型获取图标
    function getIconByType(type) {
      switch (type) {
        case 'APPROVAL':
        case 'APPROVED':
          return CheckCircleIcon;
        case 'COMPLETE':
        case 'FINISH':
          return SuccessIcon;
        case 'WARNING':
        case 'URGENT':
          return AlertIcon;
        default:
          return DocumentIcon;
      }
    }

    // 根据消息类型和紧急程度获取样式
    function getBgClassByType(item) {
      // 根据紧急程度 priority 显示不同背景 (0-普通, 1-重要, 2-紧急)
      if (item.priority === 2) {
        return 'bg-red-50 border border-red-100';
      } else if (item.priority === 1) {
        return 'bg-amber-50 border border-amber-100';
      }

      // 根据类型区分
      switch (item.rawType) {
        case 'APPROVAL':
        case 'APPROVED':
          return 'bg-blue-50 border border-blue-100';
        case 'COMPLETE':
        case 'FINISH':
          return 'bg-emerald-50 border border-emerald-100';
        case 'WARNING':
        case 'URGENT':
          return 'bg-amber-50 border border-amber-100';
        default:
          return 'bg-slate-50 border border-slate-100';
      }
    }

    // 根据消息类型和紧急程度获取图标样式
    function getIconBgClass(item) {
      if (item.priority === 2) {
        return 'status-badge is-danger';
      } else if (item.priority === 1) {
        return 'status-badge is-orange';
      }

      // 根据类型区分
      switch (item.rawType) {
        case 'APPROVAL':
        case 'APPROVED':
          return 'status-badge is-info';
        case 'COMPLETE':
        case 'FINISH':
          return 'status-badge is-success';
        case 'WARNING':
        case 'URGENT':
          return 'status-badge is-warning';
        default:
          return 'status-badge is-neutral';
      }
    }

    // 标记单条消息已读（通过共享 store）
    async function markAsRead(msg) {
      if (!msg.unread) return;
      try {
        await storeMarkAsRead(msg.id);
      } catch (error) {
        console.error('标记已读失败:', error);
      }
    }

    // 标记全部消息已读（通过共享 store）
    async function markAllRead() {
      try {
        await storeMarkAllRead();
        ElMessage.success('已全部标记为已读');
      } catch (error) {
        console.error('标记全部已读失败:', error);
        ElMessage.error('操作失败，请重试');
      }
    }

    // 判断消息是否有跳转地址
    // 处理消息跳转
    // 点击消息跳转按钮
    async function handleNavigationClick(msg) {
      if (msg.unread) {
        await markAsRead(msg);
      }
      navigateNotification(msg);
    }

    // 格式化日期
    function formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}日`;
    }
    const showTodoDetail = ref(false);
    const currentTodoItem = ref(null);

    // 打开待办详情弹窗
    function openTodoDetail(item) {
      currentTodoItem.value = {
        ...item
      };
      showTodoDetail.value = true;
    }

    // 关闭待办详情弹窗
    function closeTodoDetail() {
      showTodoDetail.value = false;
      currentTodoItem.value = null;
    }

    // 待办完成回调
    function onTodoComplete() {
      fetchDashboardTodos();
    }

    // 首页快速完成待办
    async function handleCompleteTodo(item) {
      try {
        await todoApi.complete(item.id);
        await fetchDashboardTodos();
      } catch (error) {
        console.error('完成待办失败:', error);
      }
    }

    // 今日日程数据
    const todaySchedules = ref([]);
    // 待审批任务数据
    const {
      approvalList,
      syncHandledApproval
    } = useApprovalToast();
    const pendingTasks = computed(() => approvalList.value);
    // 首页待办事项数据
    const dashboardTodos = ref([]);

    // 今日计划数据来自“我的日报”的今日工作项
    const todayWorkReport = ref(null);
    const todayPlanLoading = ref(false);
    const todayPlanSaving = ref(false);
    const showTodayPlanDialog = ref(false);
    const currentTodayPlanItem = ref(null);
    const todayPlanForm = reactive({
      result: 'IN_PROGRESS'
    });
    const todayPlanAnnotations = ref([]);
    const todayPlanAnnotationLoading = ref(false);
    const todayPlanAnnotationSubmitting = ref(false);
    const todayPlanAnnotationError = ref(false);
    const todayPlanAnnotationContent = ref('');
    let todayPlanAnnotationLoadSeq = 0;
    const todayPlanResultOptions = [{
      value: 'IN_PROGRESS',
      label: '进行中'
    }, {
      value: 'COMPLETED',
      label: '已完成'
    }];
    const todayPlanItems = computed(() => {
      return (todayWorkReport.value?.workItems || []).filter(item => item?.source !== 'UNPLANNED');
    });
    const todayPlanPendingItems = computed(() => {
      return todayPlanItems.value.filter(item => item?.result !== 'COMPLETED');
    });
    const todayPlanHasPlan = computed(() => todayPlanItems.value.length > 0);
    const todayPlanSummarySubmitted = computed(() => todayWorkReport.value?.summaryStatus === 'SUBMITTED');
    const todayPlanAnnotationDisplayCount = computed(() => todayPlanAnnotations.value.length || todayPlanTodoAnnotationCount(currentTodayPlanItem.value));

    // 我的提醒：订阅全局 composable
    const {
      dashboardList,
      processReminder
    } = useReminderToast();
    const myReminders = computed(() => dashboardList.value);
    const dashboardCardOrderMap = computed(() => {
      return [{
        key: 'schedule',
        count: todaySchedules.value.length,
        fallbackOrder: 0
      }, {
        key: 'todayPlan',
        count: todayPlanPendingItems.value.length,
        fallbackOrder: 1
      }, {
        key: 'todo',
        count: dashboardTodos.value.length,
        fallbackOrder: 2
      }, {
        key: 'reminder',
        count: myReminders.value.length,
        fallbackOrder: 3
      }, {
        key: 'approval',
        count: pendingTasks.value.length,
        fallbackOrder: 4
      }, {
        key: 'message',
        count: messageUnreadCount.value || 0,
        fallbackOrder: 5
      }].sort((a, b) => {
        if (b.count !== a.count) {
          return b.count - a.count;
        }
        return a.fallbackOrder - b.fallbackOrder;
      }).reduce((result, item, index) => {
        result[item.key] = index;
        return result;
      }, {});
    });
    function getDashboardCardOrderStyle(cardKey) {
      return {
        order: dashboardCardOrderMap.value[cardKey] ?? 0
      };
    }
    function todayPlanItemKey(item) {
      return item?.id ?? item?.clientKey ?? `${item?.source || 'PLAN'}-${item?.title || item?.todayGoal || ''}`;
    }
    function todayPlanTitle(item) {
      return item?.title || item?.todayGoal || '未命名计划';
    }
    function todayPlanDescription(item) {
      return item?.todayGoal || item?.expectedOutcome || item?.actualOutcome || item?.description || '';
    }
    function todayPlanSourceLabel(item) {
      return workReportItemSourceLabel(item?.source);
    }
    function todayPlanResultLabel(result) {
      const normalized = normalizeTodayPlanResult(result);
      return todayPlanResultOptions.find(option => option.value === normalized)?.label || '进行中';
    }
    function normalizeTodayPlanResult(result) {
      return result === 'COMPLETED' ? 'COMPLETED' : 'IN_PROGRESS';
    }
    function normalizeCollection(value) {
      if (Array.isArray(value)) return value;
      if (Array.isArray(value?.records)) return value.records;
      if (Array.isArray(value?.list)) return value.list;
      if (Array.isArray(value?.rows)) return value.rows;
      if (Array.isArray(value?.data)) return value.data;
      if (Array.isArray(value?.data?.records)) return value.data.records;
      if (Array.isArray(value?.data?.list)) return value.data.list;
      return [];
    }
    function todayPlanWorkItemId(item = currentTodayPlanItem.value) {
      return item?.id || item?.workItemId;
    }
    function todayPlanTodoAnnotationCount(item) {
      if (!item) return 0;
      const annotations = normalizeCollection(item.annotations || item.todoAnnotations);
      const count = Number(item.annotationCount ?? item.todoAnnotationCount ?? item.currentTodoSnapshot?.annotationCount ?? item.todoSnapshot?.annotationCount ?? annotations.length);
      return Number.isFinite(count) ? count : annotations.length;
    }
    function syncTodayPlanAnnotationCount(workItemId, count) {
      if (!todayWorkReport.value?.workItems?.length || !workItemId) return;
      todayWorkReport.value = {
        ...todayWorkReport.value,
        workItems: todayWorkReport.value.workItems.map(item => {
          if (String(todayPlanWorkItemId(item)) !== String(workItemId)) return item;
          return {
            ...item,
            annotationCount: count,
            todoAnnotationCount: count,
            currentTodoSnapshot: item.currentTodoSnapshot ? {
              ...item.currentTodoSnapshot,
              annotationCount: count
            } : item.currentTodoSnapshot,
            todoSnapshot: item.todoSnapshot ? {
              ...item.todoSnapshot,
              annotationCount: count
            } : item.todoSnapshot
          };
        })
      };
    }
    function isSameTodayPlanItem(left, right) {
      if (!left || !right) return false;
      if (left.id !== undefined && left.id !== null && right.id !== undefined && right.id !== null) {
        return String(left.id) === String(right.id);
      }
      if (left.clientKey && right.clientKey) {
        return left.clientKey === right.clientKey;
      }
      return left === right;
    }
    function goCreateTodayPlan() {
      router.push({
        path: '/work-reports/my',
        query: {
          reportDate: localDate(),
          phase: 'plan'
        }
      });
    }
    function goOpenTeamWorkReport() {
      router.push({
        path: '/work-reports/team',
        query: workReportAccessSummary.value?.defaultTeamScope === 'COPIED_TO_ME' ? {
          scope: 'copied'
        } : {}
      });
    }
    function goSubmitTodaySummary() {
      router.push({
        path: '/work-reports/my',
        query: {
          reportDate: localDate(),
          phase: 'summary'
        }
      });
    }
    function openTodayPlanDialog(item) {
      currentTodayPlanItem.value = item;
      todayPlanForm.result = normalizeTodayPlanResult(item?.result);
      todayPlanAnnotationContent.value = '';
      showTodayPlanDialog.value = true;
      loadTodayPlanAnnotations();
    }
    function closeTodayPlanDialog() {
      if (todayPlanSaving.value || todayPlanAnnotationSubmitting.value) return;
      todayPlanAnnotationLoadSeq += 1;
      showTodayPlanDialog.value = false;
      currentTodayPlanItem.value = null;
      todayPlanAnnotations.value = [];
      todayPlanAnnotationLoading.value = false;
      todayPlanAnnotationError.value = false;
      todayPlanAnnotationContent.value = '';
    }
    async function loadTodayPlanAnnotations() {
      const reportId = todayWorkReport.value?.id;
      const workItemId = todayPlanWorkItemId();
      if (!reportId || !workItemId) {
        todayPlanAnnotations.value = [];
        return;
      }
      const requestSeq = ++todayPlanAnnotationLoadSeq;
      todayPlanAnnotationLoading.value = true;
      todayPlanAnnotationError.value = false;
      try {
        const result = await listWorkItemTodoAnnotations(reportId, workItemId);
        if (requestSeq !== todayPlanAnnotationLoadSeq) return;
        todayPlanAnnotations.value = normalizeCollection(result);
        syncTodayPlanAnnotationCount(workItemId, todayPlanAnnotations.value.length);
      } catch (error) {
        if (requestSeq !== todayPlanAnnotationLoadSeq) return;
        console.error('加载今日计划批注失败:', error);
        todayPlanAnnotationError.value = true;
        ElMessage.error('批注加载失败，请重试');
      } finally {
        if (requestSeq === todayPlanAnnotationLoadSeq) {
          todayPlanAnnotationLoading.value = false;
        }
      }
    }
    async function submitTodayPlanAnnotation() {
      const content = todayPlanAnnotationContent.value.trim();
      const reportId = todayWorkReport.value?.id;
      const workItemId = todayPlanWorkItemId();
      if (!content || !reportId || !workItemId) return;
      todayPlanAnnotationSubmitting.value = true;
      try {
        await addWorkItemTodoAnnotation(reportId, workItemId, {
          content
        });
        todayPlanAnnotationContent.value = '';
        ElMessage.success('批注已同步');
        await loadTodayPlanAnnotations();
      } catch (error) {
        console.error('提交今日计划批注失败:', error);
        ElMessage.error('批注提交失败，请重试');
      } finally {
        todayPlanAnnotationSubmitting.value = false;
      }
    }
    async function submitTodayPlanResult() {
      if (!todayWorkReport.value?.id || !currentTodayPlanItem.value) {
        ElMessage.warning('请先创建今日计划');
        return;
      }
      const nextResult = normalizeTodayPlanResult(todayPlanForm.result);
      const nextWorkItems = (todayWorkReport.value.workItems || []).map(item => {
        if (!isSameTodayPlanItem(item, currentTodayPlanItem.value)) return item;
        return {
          ...item,
          result: nextResult
        };
      });
      todayPlanSaving.value = true;
      try {
        const updated = await saveSummaryDraft(todayWorkReport.value.id, buildTodaySummaryDraftPayload(nextWorkItems));
        todayWorkReport.value = updated || {
          ...todayWorkReport.value,
          workItems: nextWorkItems
        };
        todayPlanAnnotationLoadSeq += 1;
        showTodayPlanDialog.value = false;
        currentTodayPlanItem.value = null;
        todayPlanAnnotations.value = [];
        todayPlanAnnotationContent.value = '';
        todayPlanAnnotationError.value = false;
        ElMessage.success('计划处理结果已保存');
      } catch (error) {
        console.error('保存今日计划处理结果失败:', error);
        ElMessage.error('保存失败，请稍后重试');
      } finally {
        todayPlanSaving.value = false;
      }
    }
    function buildTodaySummaryDraftPayload(workItems) {
      return {
        reportId: todayWorkReport.value.id,
        workItems: workItems.map(normalizeDashboardWorkItemForPayload),
        achievement: todayWorkReport.value.summaryAchievement || '',
        blocker: todayWorkReport.value.summaryBlocker || '',
        assistanceNeeded: todayWorkReport.value.summaryAssistanceNeeded || '',
        supplement: todayWorkReport.value.summarySupplement || '',
        supplementReason: todayWorkReport.value.supplementReason || '',
        attachmentObjectKeys: dashboardAttachmentObjectKeys(todayWorkReport.value),
        expectedVersion: getReportOptimisticVersion(todayWorkReport.value),
        clientRequestId: createClientRequestId()
      };
    }
    function normalizeDashboardWorkItemForPayload(item) {
      const payload = {
        ...item
      };
      delete payload.clientKey;
      delete payload.progressPercent;
      delete payload.annotations;
      delete payload.todoAnnotations;
      const todoSnapshot = normalizeReportTodoSnapshot(payload.todoSnapshot);
      if (todoSnapshot) payload.todoSnapshot = todoSnapshot;
      const currentTodoSnapshot = normalizeReportTodoSnapshot(payload.currentTodoSnapshot);
      if (currentTodoSnapshot) payload.currentTodoSnapshot = currentTodoSnapshot;
      return payload;
    }
    function dashboardAttachmentObjectKeys(report) {
      return (report?.attachments || []).map(attachment => attachment.objectKey).filter(Boolean);
    }
    function localDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    // 日程详情弹窗状态
    const showEventDetail = ref(false);
    const detailEvent = ref(null);
    const detailLoading = ref(false);

    // 审批详情弹窗状态
    const showApprovalDetail = ref(false);
    const selectedApprovalTask = ref(null);
    const approvalDetail = ref(null);

    // 格式化时间显示
    function formatTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      return dateTimeStr.includes('T') ? dateTimeStr.split('T')[1]?.substring(0, 5) || '' : dateTimeStr.substring(0, 5);
    }

    // 打开日程详情弹窗
    async function openEventDetail(schedule) {
      // 先设置基本数据，确保 isOwner 和 attendeeStatus 立即可用
      detailEvent.value = {
        ...schedule,
        // 确保从 rawData 中获取 isOwner 和 attendeeStatus
        isOwner: schedule.rawData?.isOwner ?? schedule.isOwner,
        attendeeStatus: schedule.rawData?.attendeeStatus ?? schedule.attendeeStatus
      };
      showEventDetail.value = true;
      detailLoading.value = true;
      try {
        const res = await scheduleApi.getDetail(schedule.id);
        if (res) {
          // 格式化参与人列表
          const attendeeList = res.attendees?.map(a => ({
            id: a.userId,
            userId: a.userId,
            userName: a.userName || '',
            avatar: a.avatar || '',
            role: a.role,
            status: a.status
          })) || [];
          const attendeesStr = res.attendees?.map(a => a.userName || '').filter(Boolean).join('、') || '';

          // 解析日期和时间
          let date = '';
          let time = '';
          let endTime = '';
          if (res.startTime) {
            const startDt = res.startTime.includes('T') ? res.startTime.split('T')[0] : res.startTime.substring(0, 10);
            date = startDt;
            time = formatTime(res.startTime);
          }
          if (res.endTime) {
            endTime = formatTime(res.endTime);
          }

          // 合并详情数据，保留 isOwner 和 attendeeStatus（优先使用 API 返回的）
          detailEvent.value = {
            ...detailEvent.value,
            ...res,
            date: date || detailEvent.value.date,
            time: time || detailEvent.value.time,
            endTime,
            attendees: attendeesStr,
            attendeeList,
            // 明确保留邀请状态
            isOwner: res.isOwner !== undefined ? res.isOwner : detailEvent.value.isOwner,
            attendeeStatus: res.attendeeStatus !== undefined ? res.attendeeStatus : detailEvent.value.attendeeStatus
          };
        }
      } catch (error) {
        console.error('获取日程详情失败:', error);
      } finally {
        detailLoading.value = false;
      }
    }

    // 关闭日程详情弹窗
    function closeEventDetail() {
      showEventDetail.value = false;
      detailEvent.value = null;
    }

    // 响应邀请（接受/拒绝）
    async function respondToInvite(status) {
      if (!detailEvent.value) return;
      try {
        await scheduleApi.responseInvite(detailEvent.value.id, status);
        ElMessage.success(status === 2 ? '已接受邀请' : '已拒绝邀请');
        closeEventDetail();
        // 刷新今日日程
        fetchTodaySchedules();
      } catch (error) {
        console.error('响应邀请失败:', error);
        ElMessage.error('操作失败，请重试');
      }
    }

    // 获取背景样式类
    function getScheduleBgClass(schedule) {
      const baseClass = 'hover:bg-slate-50';
      switch (schedule.status) {
        case 'pending':
          return `${baseClass} bg-white border border-slate-200`;
        case 'in_progress':
          return `${baseClass} bg-blue-50 border border-blue-200`;
        case 'completed':
          return `${baseClass} bg-green-50 border border-green-200`;
        default:
          return baseClass;
      }
    }

    // 获取状态指示器颜色类
    function getScheduleStatusDotClass(schedule) {
      switch (schedule.status) {
        case 'pending':
          return 'bg-amber-500';
        case 'in_progress':
          return 'bg-blue-500';
        case 'completed':
          return 'bg-green-500';
        default:
          return 'bg-slate-400';
      }
    }

    // 查看日程详情（弹窗方式）
    function viewSchedule(schedule) {
      openEventDetail(schedule);
    }

    // 完成日程
    async function completeSchedule(schedule) {
      try {
        await scheduleApi.complete(schedule.id);
        ElMessage.success('日程已完成');
        fetchTodaySchedules();
      } catch (error) {
        console.error('完成日程失败:', error);
        ElMessage.error('操作失败，请重试');
      }
    }

    // 在首页列表中快速响应邀请
    async function respondToInviteOnList(schedule, status) {
      try {
        await scheduleApi.responseInvite(schedule.id, status);
        ElMessage.success(status === 2 ? '已接受邀请' : '已拒绝邀请');
        // 更新列表中的状态
        schedule.status = status === 2 ? 'in_progress' : 'completed';
        schedule.attendeeStatus = status;
        // 刷新今日日程列表
        fetchTodaySchedules();
      } catch (error) {
        console.error('响应邀请失败:', error);
        ElMessage.error('操作失败，请重试');
      }
    }

    // 获取今日日程
    async function fetchTodaySchedules() {
      try {
        // request拦截器会在code===0时返回data，所以res就是数组
        const data = await scheduleApi.getToday();
        // 转换API数据格式为前端所需格式
        todaySchedules.value = (data || []).map(item => {
          // 解析时间
          let time = '';
          let startTimeObj = null;
          let endTimeObj = null;
          if (item.startTime) {
            // 格式: 2026-01-26T10:30:00 或 2026-02-02 10:40:00
            const timeStr = item.startTime.includes('T') ? item.startTime.split('T')[1]?.substring(0, 5) : item.startTime.split(' ')?.[1]?.substring(0, 5) || '';
            time = timeStr;
            // 创建开始时间的Date对象（用于状态判断）
            const datePart = item.startTime.includes('T') ? item.startTime.split('T')[0] : item.startTime.split(' ')[0];
            if (timeStr && datePart) {
              startTimeObj = new Date(`${datePart}T${timeStr}:00`);
            }
          }
          if (item.endTime) {
            const timeStr = item.endTime.includes('T') ? item.endTime.split('T')[1]?.substring(0, 5) : item.endTime.split(' ')?.[1]?.substring(0, 5) || '';
            const datePart = item.endTime.includes('T') ? item.endTime.split('T')[0] : item.endTime.split(' ')[0];
            if (timeStr && datePart) {
              endTimeObj = new Date(`${datePart}T${timeStr}:00`);
            }
          }

          // 根据时间计算状态: pending-未开始, in_progress-进行中, completed-已结束
          const now = new Date();
          let status = 'pending'; // 默认未开始
          if (startTimeObj && endTimeObj) {
            if (now >= startTimeObj && now <= endTimeObj) {
              status = 'in_progress'; // 进行中
            } else if (now > endTimeObj) {
              status = 'completed'; // 已结束
            } else {
              status = 'pending'; // 未开始
            }
          } else if (startTimeObj) {
            if (now >= startTimeObj) {
              status = 'in_progress'; // 只有开始时间，已开始
            }
          }
          return {
            id: item.id,
            title: item.title || '',
            time,
            endTime: item.endTime ? item.endTime.includes('T') ? item.endTime.split('T')[1]?.substring(0, 5) : item.endTime.split(' ')?.[1]?.substring(0, 5) || '' : '',
            location: item.location || '',
            status,
            isOwner: item.isOwner !== undefined ? item.isOwner : true,
            attendeeStatus: item.attendeeStatus,
            // 获取第一个参与人的头像
            attendeeAvatar: item.attendees?.[0]?.avatar || null,
            // 原始数据（用于详情查看）
            rawData: item
          };
        });
      } catch (error) {
        console.error('获取今日日程失败:', error);
        // 使用模拟数据
        todaySchedules.value = [];
      }
    }

    // 获取今日工作计划
    async function fetchWorkReportAccessSummary() {
      try {
        workReportAccessSummary.value = {
          ...defaultWorkReportAccessSummary(),
          ...((await getWorkReportAccessSummary()) || {})
        };
      } catch (error) {
        console.error('加载日报入口权限失败:', error);
        workReportAccessSummary.value = defaultWorkReportAccessSummary();
      }
    }
    async function fetchTodayWorkReportPlans() {
      todayPlanLoading.value = true;
      try {
        const data = await getDailyWorkReport(localDate());
        todayWorkReport.value = data || null;
      } catch (error) {
        console.error('获取今日工作计划失败:', error);
        todayWorkReport.value = null;
      } finally {
        todayPlanLoading.value = false;
      }
    }

    // 处理提醒（延期提醒或标记完成）
    async function handleProcessReminder(item) {
      try {
        const result = await chooseReminderTaskAction(item);
        await processReminder(item.id, result.action, item, result);
        ElMessage.success(reminderTaskActionMessage(result.action));
      } catch (e) {
        if (e !== 'cancel' && e !== 'close') {
          ElMessage.error('操作失败');
          console.error('[Dashboard] 处理失败', e);
        }
      }
    }

    // 获取首页待办事项
    async function fetchDashboardTodos() {
      try {
        const data = await todoApi.getList({
          pageNum: 1,
          pageSize: 5,
          status: 4
        });
        dashboardTodos.value = (data?.records || []).map(item => ({
          id: item.id,
          title: item.title,
          description: item.description,
          priority: item.priority,
          priorityDesc: item.priorityDesc,
          dueDate: item.dueDate,
          overdue: item.overdue,
          status: item.status
        }));
      } catch (error) {
        console.error('获取待办事项失败:', error);
        dashboardTodos.value = [];
      }
    }

    // 打开审批详情弹窗
    function openApprovalDetail(task) {
      selectedApprovalTask.value = task;
      approvalDetail.value = null;
      showApprovalDetail.value = true;
    }

    // 关闭审批详情弹窗
    function closeApprovalDetail() {
      showApprovalDetail.value = false;
      selectedApprovalTask.value = null;
      approvalDetail.value = null;
    }

    // 通过审批（来自 ApprovalDetailModal）
    async function handleApproveFromModal({
      comment
    }) {
      if (!selectedApprovalTask.value) return;
      const handledId = selectedApprovalTask.value.id;
      try {
        await approveTask({
          instanceId: selectedApprovalTask.value.instanceId || selectedApprovalTask.value.id,
          actionType: 'AGREE',
          remark: comment
        });
        ElMessage.success('审批通过');
        closeApprovalDetail();
        syncHandledApproval(handledId);
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 驳回审批（来自 ApprovalDetailModal）
    async function handleRejectFromModal({
      comment
    }) {
      if (!selectedApprovalTask.value) return;
      const handledId = selectedApprovalTask.value.id;
      try {
        await approveTask({
          instanceId: selectedApprovalTask.value.instanceId || selectedApprovalTask.value.id,
          actionType: 'REJECT',
          remark: comment
        });
        ElMessage.success('已驳回');
        closeApprovalDetail();
        syncHandledApproval(handledId);
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 定时刷新间隔（毫秒）
    let refreshTimer = null;

    // 刷新所有数据
    function refreshAllData() {
      fetchTodaySchedules();
      fetchDashboardTodos();
      fetchTodayWorkReportPlans();
      fetchWorkReportAccessSummary();
      loadRecentMessages();
      loadUnreadCount();
    }
    onMounted(() => {
      // 立即获取数据
      refreshAllData();
      // 设置定时刷新
      refreshTimer = setInterval(refreshAllData, REFRESH_INTERVAL);
    });

    // 组件卸载时清除定时器
    onUnmounted(() => {
      if (refreshTimer) {
        clearInterval(refreshTimer);
        refreshTimer = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "flex items-center justify-between mb-4"
      }, [_createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "快捷入口"), _createElementVNode("span", {
        class: "text-xs text-slate-400"
      }, "常用操作快速访问")], -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleQuickActions.value, item => {
        return _openBlock(), _createElementBlock("button", {
          key: item.label,
          class: "group relative flex min-w-0 flex-col items-center gap-2.5 rounded-xl bg-slate-50 p-3.5 hover:-translate-y-0.5 hover:bg-primary-50 hover:shadow-md hover:shadow-primary-100/50 transition-all duration-300",
          onClick: $event => handleQuickAction(item)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          class: _normalizeClass(['flex h-10 w-10 items-center justify-center rounded-xl transition-all duration-300', item.iconBg])
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
          class: "h-4.5 w-4.5 transition-transform duration-300 group-hover:scale-110"
        }))], 2)]), _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)], 8, _hoisted_4);
      }), 128))])]), showStatisticsSection.value ? (_openBlock(), _createBlock(DashboardStatisticsSection, {
        key: 0
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('schedule'))
      }, [_createElementVNode("div", _hoisted_8, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }), _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "今日日程")], -1)), _createVNode(_component_router_link, {
        to: "/schedule",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 查看全部 ", -1), _createElementVNode("svg", {
          class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))]),
        _: 1
      })]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todaySchedules.value, schedule => {
        return _openBlock(), _createElementBlock("div", {
          key: schedule.id,
          class: _normalizeClass(["group relative flex items-center gap-3 p-3.5 rounded-xl cursor-pointer transition-all duration-200", getScheduleBgClass(schedule)]),
          onClick: $event => viewSchedule(schedule)
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString(schedule.time), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
          class: _normalizeClass(["w-2.5 h-2.5 rounded-full", getScheduleStatusDotClass(schedule)])
        }, null, 2)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(schedule.title), 1), _createElementVNode("p", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(schedule.time), 1), schedule.endTime ? (_openBlock(), _createElementBlock("span", _hoisted_16, "- " + _toDisplayString(schedule.endTime), 1)) : _createCommentVNode("", true), schedule.location ? (_openBlock(), _createElementBlock("span", _hoisted_17, "· " + _toDisplayString(schedule.location), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_18, [schedule.status === 'completed' ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已结束")) : schedule.status === 'in_progress' ? (_openBlock(), _createElementBlock("span", _hoisted_20, "进行中")) : schedule.status === 'pending' ? (_openBlock(), _createElementBlock("span", _hoisted_21, "未开始")) : _createCommentVNode("", true), schedule.status === 'in_progress' && schedule.isOwner ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          onClick: _withModifiers($event => completeSchedule(schedule), ["stop"]),
          class: "px-2.5 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors"
        }, "完成", 8, _hoisted_22)) : !schedule.isOwner && schedule.attendeeStatus === 1 ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "flex items-center gap-1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("button", {
          onClick: $event => respondToInviteOnList(schedule, 2),
          class: "p-1.5 rounded-lg bg-emerald-100 hover:bg-emerald-200 text-emerald-700 transition-colors",
          title: "接受"
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_23), _createElementVNode("button", {
          onClick: $event => respondToInviteOnList(schedule, 3),
          class: "p-1.5 rounded-lg bg-red-100 hover:bg-red-200 text-red-700 transition-colors",
          title: "拒绝"
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))], 8, _hoisted_24)])) : _createCommentVNode("", true), _cache[11] || (_cache[11] = _createElementVNode("svg", {
          class: "w-4 h-4 text-slate-300 group-hover:text-primary-400 transition-colors",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1))])], 10, _hoisted_9);
      }), 128)), todaySchedules.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-slate-300",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      })])], -1)), _cache[14] || (_cache[14] = _createElementVNode("p", {
        class: "text-sm text-slate-400"
      }, "今日暂无日程", -1)), _createVNode(_component_router_link, {
        to: "/schedule",
        class: "mt-2 text-xs text-primary-600 hover:text-primary-700"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("去添加日程", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true)])], 4), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('todayPlan'))
      }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }, null, -1)), _cache[16] || (_cache[16] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "今日计划", -1)), todayPlanPendingItems.value.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(todayPlanPendingItems.value.length), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
        type: "button",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors",
        onClick: goCreateTodayPlan
      }, [...(_cache[17] || (_cache[17] = [_createTextVNode(" 我的日报 ", -1), _createElementVNode("svg", {
        class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      })], -1)]))]), canOpenTeamWorkReport.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors",
        onClick: goOpenTeamWorkReport
      }, [...(_cache[18] || (_cache[18] = [_createTextVNode(" 团队日报 ", -1), _createElementVNode("svg", {
        class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      })], -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [todayPlanLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[19] || (_cache[19] = [_createElementVNode("div", {
        class: "app-spinner"
      }, null, -1), _createElementVNode("p", {
        class: "mt-3 text-sm text-slate-400"
      }, "正在加载今日计划...", -1)]))])) : todayPlanSummarySubmitted.value ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[20] || (_cache[20] = [_createStaticVNode("<div class=\"w-16 h-16 rounded-2xl bg-emerald-100 flex items-center justify-center mb-3\" data-v-85ab714e><svg class=\"w-8 h-8 text-emerald-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-85ab714e><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z\" data-v-85ab714e></path></svg></div><p class=\"text-sm font-medium text-slate-700\" data-v-85ab714e>今日计划已完成并提交</p><p class=\"mt-1 text-xs text-slate-400\" data-v-85ab714e>今日日报总结已提交，无需继续处理。</p>", 3)]))])) : !todayPlanHasPlan.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-emerald-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-emerald-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2m-4 0a2 2 0 114 0m-4 0a2 2 0 104 0m-6 8h6m-6 4h6"
      })])], -1)), _cache[22] || (_cache[22] = _createElementVNode("p", {
        class: "text-sm text-slate-400"
      }, "今日暂无工作计划", -1)), _createElementVNode("button", {
        type: "button",
        class: "mt-2 text-xs text-primary-600 hover:text-primary-700 transition-colors",
        onClick: goCreateTodayPlan
      }, "去创建计划")])) : todayPlanPendingItems.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todayPlanPendingItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: todayPlanItemKey(item),
          class: "group relative flex items-start gap-3 p-3.5 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-sm bg-slate-50 border border-slate-200",
          onClick: $event => openTodayPlanDialog(item)
        }, [_cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "flex flex-col items-center gap-1 py-0.5 shrink-0"
        }, [_createElementVNode("div", {
          class: "w-2.5 h-2.5 rounded-full bg-emerald-500"
        }), _createElementVNode("div", {
          class: "w-0.5 h-4 rounded-full bg-emerald-200"
        })], -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("p", _hoisted_37, _toDisplayString(todayPlanTitle(item)), 1), _createElementVNode("span", _hoisted_38, _toDisplayString(todayPlanSourceLabel(item)), 1), _createElementVNode("span", _hoisted_39, _toDisplayString(todayPlanResultLabel(item.result)), 1)]), todayPlanDescription(item) ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(todayPlanDescription(item)), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
          type: "button",
          class: "self-center shrink-0 rounded-lg bg-primary-700 px-3.5 py-1.5 text-xs font-medium text-white shadow-sm transition-all hover:bg-primary-800 hover:shadow-md",
          onClick: _withModifiers($event => openTodayPlanDialog(item), ["stop"])
        }, " 处理 ", 8, _hoisted_41)], 8, _hoisted_34);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-emerald-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-emerald-500",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      })])], -1)), _cache[25] || (_cache[25] = _createElementVNode("p", {
        class: "text-sm font-medium text-slate-700"
      }, "今日计划已全部处理", -1)), _createElementVNode("button", {
        type: "button",
        class: "mt-2 text-xs text-primary-600 hover:text-primary-700 transition-colors",
        onClick: goSubmitTodaySummary
      }, "去提交总结")]))])], 4), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('todo'))
      }, [_createElementVNode("div", _hoisted_43, [_cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }), _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "待办事项")], -1)), _createVNode(_component_router_link, {
        to: "/todo",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors"
      }, {
        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" 查看全部 ", -1), _createElementVNode("svg", {
          class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))]),
        _: 1
      })]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [dashboardTodos.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardTodos.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["group relative flex items-start gap-3 p-3.5 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-sm", item.overdue ? 'bg-red-50 border border-red-100' : 'bg-slate-50 border border-slate-200']),
          onClick: $event => openTodoDetail(item)
        }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", {
          class: _normalizeClass(["w-2.5 h-2.5 rounded-full", item.overdue ? 'bg-red-500' : item.priority >= 3 ? 'bg-orange-500' : 'bg-amber-500'])
        }, null, 2), _createElementVNode("div", {
          class: _normalizeClass(["w-0.5 h-4 rounded-full", item.overdue ? 'bg-red-200' : item.priority >= 3 ? 'bg-orange-200' : 'bg-amber-200'])
        }, null, 2)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("p", _hoisted_49, _toDisplayString(item.title), 1), item.overdue ? (_openBlock(), _createElementBlock("span", _hoisted_50, "逾期")) : _createCommentVNode("", true)]), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(item.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
          type: "button",
          class: "px-3.5 py-1.5 bg-primary-700 text-white text-xs font-medium rounded-lg hover:bg-primary-800 shadow-sm hover:shadow-md transition-all whitespace-nowrap self-center shrink-0",
          onClick: _withModifiers($event => handleCompleteTodo(item), ["stop"])
        }, " 完成 ", 8, _hoisted_52), _createElementVNode("div", _hoisted_53, [_createElementVNode("span", {
          class: _normalizeClass(["px-2 py-0.5 text-xs font-medium rounded-full", [item.overdue ? 'bg-red-100 text-red-700' : item.priority === 4 ? 'bg-red-100 text-red-700' : item.priority === 3 ? 'bg-orange-100 text-orange-700' : item.priority === 2 ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-600']])
        }, _toDisplayString(item.priorityDesc || (item.priority === 1 ? '低' : item.priority === 2 ? '中' : item.priority === 3 ? '高' : item.priority === 4 ? '紧急' : '普通')), 3), item.dueDate ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(formatDate(item.dueDate)), 1)) : _createCommentVNode("", true)]), _cache[28] || (_cache[28] = _createElementVNode("svg", {
          class: "w-4 h-4 text-slate-300 group-hover:text-primary-400 transition-colors self-center shrink-0",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1))], 10, _hoisted_45);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_55, [_cache[30] || (_cache[30] = _createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-emerald-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-emerald-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      })])], -1)), _cache[31] || (_cache[31] = _createElementVNode("p", {
        class: "text-sm text-slate-400"
      }, "所有任务已完成", -1)), _createVNode(_component_router_link, {
        to: "/todo",
        class: "mt-2 text-xs text-primary-600 hover:text-primary-700"
      }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("去创建新任务", -1)]))]),
        _: 1
      })]))])], 4), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('reminder'))
      }, [_createElementVNode("div", _hoisted_56, [_cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }), _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "我的提醒")], -1)), _createVNode(_component_router_link, {
        to: "/reminders/my-tasks",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors"
      }, {
        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" 查看全部 ", -1), _createElementVNode("svg", {
          class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))]),
        _: 1
      })]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [myReminders.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_57, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myReminders.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "group relative flex items-start gap-3 p-3.5 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-sm bg-slate-50 border border-slate-200"
        }, [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "w-10 h-10 rounded-xl bg-white border border-orange-200 flex items-center justify-center shadow-sm shrink-0 group-hover:shadow-md transition-all"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-orange-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        })])], -1)), _createElementVNode("div", _hoisted_58, [_createElementVNode("p", _hoisted_59, _toDisplayString(item.title || '未命名提醒'), 1), _createElementVNode("p", _hoisted_60, _toDisplayString(item.content || '暂无内容'), 1)]), item.status !== 'CLOSED' ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _withModifiers($event => handleProcessReminder(item), ["stop"]),
          class: "px-3.5 py-1.5 bg-primary-700 text-white text-xs font-medium rounded-lg hover:bg-primary-800 shadow-sm hover:shadow-md transition-all whitespace-nowrap self-center shrink-0"
        }, "处理", 8, _hoisted_61)) : _createCommentVNode("", true), _cache[35] || (_cache[35] = _createElementVNode("svg", {
          class: "w-4 h-4 text-slate-300 group-hover:text-orange-400 transition-colors self-center shrink-0",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1))]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_62, [_cache[37] || (_cache[37] = _createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-orange-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-orange-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      })])], -1)), _cache[38] || (_cache[38] = _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无待处理提醒", -1)), _createVNode(_component_router_link, {
        to: "/reminders/my-tasks",
        class: "mt-2 text-xs text-primary-600 hover:text-primary-700"
      }, {
        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("去处理提醒", -1)]))]),
        _: 1
      })]))])], 4), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('approval'))
      }, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[39] || (_cache[39] = _createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }, null, -1)), _cache[40] || (_cache[40] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "待审批", -1)), pendingTasks.value.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(pendingTasks.value.length), 1)) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
        to: "/approval",
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors"
      }, {
        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode(" 查看全部 ", -1), _createElementVNode("svg", {
          class: "w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))]),
        _: 1
      })]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [pendingTasks.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingTasks.value, task => {
        return _openBlock(), _createElementBlock("div", {
          key: task.id,
          class: "group relative flex items-center gap-3 p-3.5 rounded-xl bg-slate-50 hover:bg-primary-50 border border-transparent hover:border-primary-100 cursor-pointer transition-all duration-200 hover:shadow-sm",
          onClick: $event => openApprovalDetail(task)
        }, [_cache[45] || (_cache[45] = _createElementVNode("div", {
          class: "w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center shadow-sm shrink-0 group-hover:shadow-md group-hover:border-blue-200 transition-all"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-blue-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })])], -1)), _createElementVNode("div", _hoisted_68, [_createElementVNode("p", _hoisted_69, _toDisplayString(task.title), 1), _createElementVNode("p", _hoisted_70, [_cache[44] || (_cache[44] = _createElementVNode("svg", {
          class: "w-3 h-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        })], -1)), _createTextVNode(" " + _toDisplayString(task.applicantName), 1), task.applicantRole ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_cache[42] || (_cache[42] = _createTextVNode("（", -1)), _createElementVNode("span", _hoisted_71, _toDisplayString(task.applicantRole), 1), _cache[43] || (_cache[43] = _createTextVNode("）", -1))], 64)) : _createCommentVNode("", true)])]), _createElementVNode("button", {
          onClick: _withModifiers($event => openApprovalDetail(task), ["stop"]),
          class: "px-3.5 py-1.5 bg-primary-700 text-white text-xs font-medium rounded-lg hover:bg-primary-800 shadow-sm hover:shadow-md transition-all whitespace-nowrap"
        }, "审批", 8, _hoisted_72), _cache[46] || (_cache[46] = _createElementVNode("svg", {
          class: "w-4 h-4 text-slate-300 group-hover:text-blue-400 transition-colors",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1))], 8, _hoisted_67);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_73, [...(_cache[47] || (_cache[47] = [_createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-blue-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-blue-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      })])], -1), _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无待审批任务", -1)]))]))])], 4), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardClass),
        style: _normalizeStyle(getDashboardCardOrderStyle('message'))
      }, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_cache[48] || (_cache[48] = _createElementVNode("div", {
        class: "w-1.5 h-6 bg-primary-500 rounded-full"
      }, null, -1)), _cache[49] || (_cache[49] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "通知消息", -1)), _unref(messageUnreadCount) > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_unref(messageUnreadCount)), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
        onClick: markAllRead,
        class: "group flex items-center gap-1 text-xs text-slate-400 hover:text-primary-600 transition-colors"
      }, [...(_cache[50] || (_cache[50] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
      })], -1), _createTextVNode(" 全部已读 ", -1)]))])]), _createElementVNode("div", {
        class: _normalizeClass(dashboardCardBodyClass)
      }, [notifications.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_77, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, msg => {
        return _openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: _normalizeClass(["group relative flex items-start gap-3 p-3.5 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-sm", msg.bgClass]),
          onClick: $event => markAsRead(msg)
        }, [_createElementVNode("div", {
          class: _normalizeClass(['w-9 h-9 rounded-lg flex items-center justify-center shrink-0', msg.iconBg])
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(msg.icon), {
          class: "w-4.5 h-4.5"
        }))], 2), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_createElementVNode("p", _hoisted_81, _toDisplayString(msg.title), 1), msg.priority === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_82, "紧急")) : msg.priority === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_83, "重要")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_84, _toDisplayString(msg.desc), 1)]), _createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(msg.time), 1), _unref(hasNotificationNavigation)(msg) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 px-1.5 py-0.5 rounded hover:bg-primary-50 transition-colors cursor-pointer",
          onClick: _withModifiers($event => handleNavigationClick(msg), ["stop"])
        }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
          class: "w-3 h-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        })], -1), _createTextVNode(" 查看 ", -1)]))], 8, _hoisted_87)) : _createCommentVNode("", true)]), msg.unread ? (_openBlock(), _createElementBlock("div", _hoisted_88)) : _createCommentVNode("", true)], 10, _hoisted_78);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_89, [...(_cache[52] || (_cache[52] = [_createElementVNode("div", {
        class: "w-16 h-16 rounded-2xl bg-violet-100 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-violet-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      })])], -1), _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无通知消息", -1)]))]))])], 4)])]), _createVNode(ScheduleDetailModal, {
        show: showEventDetail.value,
        event: detailEvent.value,
        loading: detailLoading.value,
        "show-edit": false,
        "show-cancel": false,
        onClose: closeEventDetail,
        onAccept: _cache[1] || (_cache[1] = () => respondToInvite(2)),
        onDecline: _cache[2] || (_cache[2] = () => respondToInvite(3))
      }, null, 8, ["show", "event", "loading"]), _createVNode(ApprovalDetailModal, {
        modelValue: showApprovalDetail.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showApprovalDetail.value = $event),
        "instance-id": selectedApprovalTask.value?.instanceId || selectedApprovalTask.value?.id,
        "detail-data": approvalDetail.value,
        "show-actions": true,
        "show-comment-editor": true,
        onApprove: handleApproveFromModal,
        onReject: handleRejectFromModal,
        onClose: closeApprovalDetail
      }, null, 8, ["modelValue", "instance-id", "detail-data"]), _createVNode(TodoDetailModal, {
        show: showTodoDetail.value,
        item: currentTodoItem.value,
        onClose: closeTodoDetail,
        onComplete: onTodoComplete
      }, null, 8, ["show", "item"]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showTodayPlanDialog.value,
          size: "2xl",
          "panel-class": "max-h-[86vh]",
          "z-index": 2000,
          scrollable: false,
          onClose: closeTodayPlanDialog
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("h3", _hoisted_92, _toDisplayString(currentTodayPlanItem.value ? todayPlanTitle(currentTodayPlanItem.value) : '工作计划'), 1), currentTodayPlanItem.value && todayPlanDescription(currentTodayPlanItem.value) ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(todayPlanDescription(currentTodayPlanItem.value)), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
            onClick: closeTodayPlanDialog
          }, [...(_cache[53] || (_cache[53] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("form", {
            class: "min-h-0 flex-1 space-y-4 overflow-y-auto px-6 py-5",
            onSubmit: _withModifiers(submitTodayPlanResult, ["prevent"])
          }, [_createElementVNode("section", _hoisted_94, [_cache[54] || (_cache[54] = _createElementVNode("span", {
            class: "form-label"
          }, "处理状态", -1)), _createElementVNode("div", _hoisted_95, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(todayPlanResultOptions, option => {
            return _createElementVNode("label", {
              key: option.value,
              class: _normalizeClass(["flex cursor-pointer items-center justify-center rounded-lg border px-3 py-2 text-sm font-medium transition-colors", todayPlanForm.result === option.value ? 'border-primary-300 bg-primary-50 text-primary-700' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'])
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => todayPlanForm.result = $event),
              class: "sr-only",
              type: "radio",
              value: option.value
            }, null, 8, _hoisted_96), [[_vModelRadio, todayPlanForm.result]]), _createTextVNode(" " + _toDisplayString(option.label), 1)], 2);
          }), 64))])]), _createElementVNode("section", _hoisted_97, [_createElementVNode("header", _hoisted_98, [_cache[55] || (_cache[55] = _createElementVNode("div", {
            class: "min-w-0"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "批注"), _createElementVNode("p", {
            class: "mt-0.5 text-xs text-slate-500"
          }, "查看并同步待办批注")], -1)), _createElementVNode("span", _hoisted_99, _toDisplayString(todayPlanAnnotationDisplayCount.value) + " 条", 1)]), _createElementVNode("div", _hoisted_100, [todayPlanAnnotationLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_101, [...(_cache[56] || (_cache[56] = [_createElementVNode("div", {
            class: "app-spinner is-sm"
          }, null, -1), _createTextVNode(" 正在加载批注... ", -1)]))])) : todayPlanAnnotationError.value ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_cache[57] || (_cache[57] = _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "批注加载失败，请重试。", -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: loadTodayPlanAnnotations
          }, "重试")])) : !todayPlanAnnotations.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_103, " 暂无批注 ")) : (_openBlock(), _createElementBlock("div", _hoisted_104, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todayPlanAnnotations.value, annotation => {
            return _openBlock(), _createElementBlock("div", {
              key: annotation.id || annotation.createTime || annotation.content,
              class: "rounded-lg border border-slate-100 bg-slate-50/70 px-3.5 py-3"
            }, [_createElementVNode("div", _hoisted_105, [_createElementVNode("span", _hoisted_106, _toDisplayString(annotation.creatorName || annotation.createByName || annotation.authorName || '未知用户'), 1), _createElementVNode("span", null, _toDisplayString(annotation.createTime || annotation.createdAt || ''), 1)]), _createElementVNode("p", _hoisted_107, _toDisplayString(annotation.content || annotation.remark || '--'), 1)]);
          }), 128))]))]), _createElementVNode("footer", _hoisted_108, [_createElementVNode("label", _hoisted_109, [_cache[58] || (_cache[58] = _createElementVNode("span", {
            class: "form-label"
          }, "新增批注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => todayPlanAnnotationContent.value = $event),
            class: "form-textarea mt-1 w-full",
            rows: "3",
            maxlength: "1000",
            placeholder: "请输入批注内容"
          }, null, 512), [[_vModelText, todayPlanAnnotationContent.value]])]), _createElementVNode("div", _hoisted_110, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: todayPlanAnnotationSubmitting.value || !todayPlanAnnotationContent.value.trim(),
            onClick: submitTodayPlanAnnotation
          }, _toDisplayString(todayPlanAnnotationSubmitting.value ? '提交中' : '提交批注'), 9, _hoisted_111)])])]), _createElementVNode("div", _hoisted_112, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: todayPlanSaving.value,
            onClick: closeTodayPlanDialog
          }, "取消", 8, _hoisted_113), _createElementVNode("button", {
            type: "submit",
            class: "btn-primary",
            disabled: todayPlanSaving.value
          }, _toDisplayString(todayPlanSaving.value ? '保存中' : '保存处理结果'), 9, _hoisted_114)])], 32)]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))], 64);
    };
  }
};